import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => {
	return {
		bottomContainer: {
			borderTop       : theme.other.darkMode ? "none" : `solid 1px ${ theme.other.colors.border.primary }`,
			width           : "100%",
			display         : "flex",
			alignItems      : "center",
			justifyContent  : "end",
			backgroundColor : theme.other.colors.dialog.primary,
			padding         : "1rem 1.5rem",
			borderRadius    : "1rem"
		},
		submitBtn: {
		},
		cancelBtn: {
			all        : "unset",
			fontWeight : "500",
			color      : theme.other.paletteNew.primaryDarkBlue,
			cursor     : "pointer"
		}
	};
} );

